import WKT from 'ol/format/WKT';
import { getCenter } from 'ol/extent';
import LocationsAfter from './LocationsAfter';

const AnchorageAfter = ({
  anchoragename,
  dok_name,
  reportingname,
  unlocationcode,
  mainmunicipality,
  nni_text,
  voyagereporting,
  'voyagereporting/voyagereportingname': voyagereporting_name,
  'voyagereporting/website': voyagereporting_website,
  vts,
  'vts/vtsname': vts_vtsname,
  'vts/phone': vts_phone,
  'vts/email': vts_email,
  'vts/vhf': vts_vhf,
  pilotage,
  'pilotage/pilotagename': pilotage_pilotagename,
  'pilotage/pilotageinfo': pilotage_pilotageinfo,
  'pilotage/phone': pilotage_phone,
  port,
  'port/portname': port_portname,
  'port/phone': port_phone,
  tug,
  'tug/tugname': tug_tugname,
  'tug/phone': tug_phone,
  geom
}) => {
  let lon = null;
  let lat = null;

  if (geom) {
    const wktFormat = new WKT();

    // Parse WKT string into a geometry object (any WKT geometry type)
    const geometry = wktFormat.readGeometry(geom, {
      dataProjection: 'EPSG:3857',
      featureProjection: 'EPSG:4326'
    });

    const centerpoint = getCenter(geometry.getExtent());
    [lon, lat] = centerpoint;
  }

  return (
    <>
      <h3>{anchoragename}</h3>
      <div style={{ marginBottom: -10 }}>
        <div className="additional">
          <h5>Norwegian</h5>
          <p>{dok_name}</p>
        </div>
        <div className="additional">
          <h5>Reporting name</h5>
          <p>{reportingname}</p>
        </div>
        <div className="additional">
          <h5>UN/LOCODE</h5>
          <p>{unlocationcode}</p>
        </div>
        <div className="additional">
          <h5>Main municipality</h5>
          <p>{mainmunicipality}</p>
        </div>
        <div className="additional">
          <h5>Information</h5>
          <p>{nni_text}</p>
        </div>
        {voyagereporting && (
          <div className="additional">
            <h5>Contact Voyage reporting</h5>
            <p>{[voyagereporting_name, voyagereporting_website].filter(Boolean).join(', ')}</p>
          </div>
        )}
        {vts && (
          <div className="additional">
            <h5>Contact point - VTS</h5>
            <p>{
              [
                vts_vtsname,
                vts_phone && `phone: ${vts_phone}`,
                vts_email && `E-mail: ${vts_email}`,
                vts_vhf && `VHF: ${vts_vhf}`
              ].filter(Boolean).join(', ')
            }</p>
          </div>
        )}
        {pilotage && (
          <div className="additional">
            <h5>Contact point - Pilotage</h5>
            <p>{
              [
                pilotage_pilotagename,
                pilotage_pilotageinfo,
                pilotage_phone && `phone: ${pilotage_phone}`
              ].filter(Boolean).join(', ')
            }</p>
          </div>
        )}
        {port && (
          <div className="additional">
            <h5>Contact point - Port</h5>
            <p>{
              [
                port_portname,
                port_phone && `phone: ${port_phone}`
              ].filter(Boolean).join(', ')
            }</p>
          </div>
        )}
        {tug && (
          <div className="additional">
            <h5>Contact point - Tug</h5>
            <p>{
              [
                tug_tugname,
                tug_phone && `phone: ${tug_phone}`
              ].filter(Boolean).join(', ')
            }</p>
          </div>
        )}
      </div>
      {lat && lon && (
        <LocationsAfter
          lat={lat}
          lon={lon}
        />
      )}
    </>
  );
};

export default AnchorageAfter;
